import gql from "graphql-tag";

const GET_POOLS = gql`
    query pools (
      $type: String!
      $rows: Int!
      $page: Int!
    ) {
          pools(
            poolSearchQuery: {
              search: ""
              type: $type
              rows: $rows
              listType: "all"
              page: $page
            }
          ) {
            rows {
              id
              slug
              name
              ticker
              description
              ath
              poolTokenPrice
              image
              banner
              contributionStartDate
              contributionEndDate
              pledgeStartDate
              pledgeEndDate
              pledgeEndDate
              totalCap
              maxRaise
              totalRaised
              status
              kycUrl
              kycDeadlineDate
              usdPerTicketValue
              distributionStatusDescription
              distributionScAddress {
                networkId
                token
                address
                chain
                isClaimable
                isAirdropped
              }
              networks {
                networkId
                address
                token
              }
              socialNetworks {
                website
                telegram
                whitePaper
                twitter
              }
              refundPolicy {
                refundable
                explicitRefundWindowInSeconds
              }
              investments {
                id
                amount
                userId
                walletId
                poolId
                isTrxVerified
                receivingAddress
                totalTokenEarned
                totalTokenClaimed
                totalTokenClaimable
                refundPayload {
                  status
                  requestedDate
                  refundedDate
                }
              }
              poolStakingConfigs {
                id
                withdrawalRules {
                  duration
                  apy
                }
                earlyWithdrawalPenalty
                networkId
                tokenAddress
                maxCap
                stakingDeadline
                poolStakeAddress
                referralProgramEnabled
                defaultRefereeRewardPercent
                defaultReferrerRewardPercent
              }
            }
            page
            totalPages
            count
          }
        }
`

export default GET_POOLS;